(() => {
  if (customElements.get('slib-sticky-header')) return;

  class SlibStickyHeader extends HTMLElement {
    connectedCallback() {
      this.type = this.dataset.stickyType || 'none';
      this.lastScrollTop = window.scrollY;
      this.onScroll = this.onScroll.bind(this);

      if (this.type !== 'none') {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      const currentScrollTop = window.scrollY;
      const shouldHide = this.type === 'on-scroll-up' && currentScrollTop > this.lastScrollTop && currentScrollTop > this.offsetHeight;

      this.classList.toggle('slib-header-wrapper--hidden', shouldHide);
      this.classList.toggle('slib-header-wrapper--scrolled', currentScrollTop > this.offsetHeight);
      this.lastScrollTop = currentScrollTop;
    }
  }

  customElements.define('slib-sticky-header', SlibStickyHeader);
})();
